import { Component, EventEmitter, Input, Output } from '@angular/core';
import { LoginFormComponent } from '../login-form/login-form.component';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-login-modal',
  standalone: true,
  imports: [CommonModule, LoginFormComponent],
  templateUrl: './login-modal.component.html',
  styleUrls: ['./login-modal.component.scss']
})
export class LoginModalComponent {

  @Input() modalRef: NgbModalRef | undefined;
  @Input() errorText: boolean = false;
  isLoggedIn: boolean = false;

  onLoginSuccess() {
    this.isLoggedIn = true;
    if (this.modalRef) {
      this.modalRef.dismiss();
    }
  }
}
